import { motion } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";
import { CONTACT } from "@/data/content";
import { CTAButton } from "@/components/ui-bits";
import { Reveal } from "@/components/motion-primitives";

export const StrongCTA = () => (
  <section className="relative py-24 md:py-28 bg-brand-dark grain overflow-hidden">
    <div className="absolute inset-0 dot-grid opacity-[0.12]" />
    <motion.div
      aria-hidden="true"
      className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-secondary/20 blur-3xl"
      animate={{ scale: [1, 1.15, 1], opacity: [0.5, 0.8, 0.5] }}
      transition={{ repeat: Infinity, duration: 8, ease: "easeInOut" }}
    />
    <div className="container mx-auto px-4 md:px-8 relative">
      <div className="max-w-3xl">
        <Reveal>
          <span className="overline text-secondary">Ready when you are</span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight text-white leading-[1.05]">
            Need help with your municipal account?
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-base md:text-lg text-white/70 leading-relaxed max-w-2xl">
            Don&rsquo;t let your municipal query remain unresolved while you&rsquo;re sent from one department to another.
            Let SML Municipal Consulting manage the process on your behalf.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <CTAButton href="#quote" variant="secondary" size="lg" icon={ArrowRight} testId="strong-cta-quote">Request a Quote</CTAButton>
            <CTAButton href={`tel:${CONTACT.phoneRaw}`} variant="outline" size="lg" icon={Phone} testId="strong-cta-call">Call {CONTACT.phone}</CTAButton>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
